module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "top-page"
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h1', [_vm._v("\n                        Add a new Users\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "cc-w-auto cc-right"
  }, [_c('router-link', {
    staticClass: "btn cc-bg-green fa-angle-left",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("Back to users")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-inside"
  }, [_c('form', {
    staticClass: "boxed",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.lastname.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.lastname),
      expression: "user.lastname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "lastname"
    },
    domProps: {
      "value": (_vm.user.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastname = $event.target.value.trim()
      }, function($event) {
        _vm.$v.user.lastname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.lastname.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Name must have at least " + _vm._s(_vm.$v.user.lastname.$params.minLength.min) + " letters.\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.lastname.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Field is required\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.firstname.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.firstname),
      expression: "user.firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "firstname"
    },
    domProps: {
      "value": (_vm.user.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstname = $event.target.value.trim()
      }, function($event) {
        _vm.$v.user.firstname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.firstname.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Name must have at least " + _vm._s(_vm.$v.user.firstname.$params.minLength.min) + " letters.\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.firstname.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Field is required\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.age.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.age),
      expression: "user.age",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "number",
      "name": "age"
    },
    domProps: {
      "value": (_vm.user.age)
    },
    on: {
      "blur": [function($event) {
        _vm.$v.user.age.$touch()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.age = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.age.between) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Must be between " + _vm._s(_vm.$v.user.age.$params.between.min) + " and " + _vm._s(_vm.$v.user.age.$params.between.max) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.email.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.email),
      expression: "user.email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value.trim()
      }, function($event) {
        _vm.$v.user.email.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.email.email) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Must be an email format \"@\"\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.email.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Field is required\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.password.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.password),
      expression: "user.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value.trim()
      }, function($event) {
        _vm.$v.user.password.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.password.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        This field is required\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.password.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Name must have at least " + _vm._s(_vm.$v.user.password.$params.minLength.min) + " letters.\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item cc-txt-center",
    class: {
      'error': _vm.$v.user.confirmPassword.$error
    }
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "name": "confirmPassword"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirmPassword = $event.target.value.trim()
      }, function($event) {
        _vm.$v.user.confirmPassword.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.user.confirmPassword.required) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        This field is required\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.confirmPassword.sameAsPassword) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Must be identical to Password field\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.confirmPassword.minLength) ? _c('span', {
    staticClass: "warning"
  }, [_vm._v("\n                        Name must have at least " + _vm._s(_vm.$v.user.confirmPassword.$params.minLength.min) + " letters.\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-txt-center"
  }, [_c('button', {
    ref: "submitButton",
    staticClass: "fa-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    class: [{
      'active': _vm.modalSuccess
    }, 'modal']
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.modalSuccess = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.modalSuccess = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n                        Registration success\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-info fa-thumbs-up"
  }, [_vm._v("\n                            User registered with success\n                        ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35ac6cbd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/persons/users/user-add.vue
// module id = 220
// module chunks = 0